import { Component } from '@angular/core';

@Component({
  selector: 'cms-geoguide-lab',
  template: `
    <cms-geoguide></cms-geoguide>
  `
})
export class GeoGuideLabComponent {}
